/* Keep the Volkswagen comparison and the actual selected kit in sync. */
(() => {
 function init(root) {
  if (root.dataset.vwSelectionReady) return;
  root.dataset.vwSelectionReady = 'true';
  const product = document.querySelector('[data-gob-daylight]');
  root.querySelectorAll('[data-bestseller-level]').forEach(button => button.addEventListener('click', () => {
   const title = button.querySelector('strong').textContent;
   const radio = [...(product?.querySelectorAll('.d-v input[type="radio"]') || [])].find(item => item.value === title);
   if (radio && !radio.disabled) radio.click();
  }));
 }
 const start = () => document.querySelectorAll('[data-gob-six-story][data-set="10220"]').forEach(init);
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
 document.addEventListener('shopify:section:load', start);
})();
